<template>
      <div class="link-container">
        <img src="../../assets/serviceimg/md-logo.png" @click="window.open('https://web.meindienstplan.at', '_blank')"/>
        <img src="../../assets/serviceimg/mz-logo.png" @click="window.open('https://www.meinezeiterfassung.at', '_blank')"/>
        <img src="../../assets/serviceimg/mp-logo.png" class="mp" @click="window.open('https://www.meinplayer.at', '_blank')"/>
        <img src="../../assets/serviceimg/ml-logo.png" @click="window.open('https://web.meinelohnabrechnung.at/', '_blank')"/>
      </div>
</div>
</template>

<script>
    export default {
        name: "links",
        data() {
          return {
            window: window,
          }
        },
    }
</script>

<style scoped>
  .link-container{
    text-align: center;

    left: 0;
    right: 0;
    margin: auto;
    white-space: nowrap;
    height: min-content;
    position: fixed;
    margin-top: -260px;
    margin-top: -282px;
    padding-left: 5px;
  }

  .link-container img{
    cursor: pointer;
    width: 60px;
    height: 60px;
    margin: 0 9px;
  }

</style>
